/**
 * @generated SignedSource<<0e2df8bd6aeb473f6c3aa813125501e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteApiKeyInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteApiKeyMutation$variables = {
  input: DeleteApiKeyInput;
};
export type deleteApiKeyMutation$data = {
  readonly deleteApiKey: {
    readonly deletedApiKeyId: string | null;
  } | null;
};
export type deleteApiKeyMutation = {
  variables: deleteApiKeyMutation$variables;
  response: deleteApiKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteApiKeyPayload",
    "kind": "LinkedField",
    "name": "deleteApiKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedApiKeyId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteApiKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteApiKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b74ae59df4f4a71799ee770a6cba469c",
    "id": null,
    "metadata": {},
    "name": "deleteApiKeyMutation",
    "operationKind": "mutation",
    "text": "mutation deleteApiKeyMutation(\n  $input: DeleteApiKeyInput!\n) {\n  deleteApiKey(input: $input) {\n    deletedApiKeyId\n  }\n}\n"
  }
};
})();

(node as any).hash = "f0573a54abffb100e0719daf52521288";

export default node;
